
import { apiKey } from './config'; // Update the path if needed
import ToastService from './services/ToastService';


export function resolveApiBaseUrl(
    configuredBaseUrl = process.env.REACT_APP_API_BASE_URL,
    location = window.location,
    isDevelopment = process.env.NODE_ENV === 'development',
) {
    const configuredUrl = configuredBaseUrl?.trim();
    if (configuredUrl) return configuredUrl.replace(/\/$/, '');

    if (isDevelopment && location?.hostname) {
        return `http://${location.hostname}:5080/api`;
    }

    return '/api';
}

export const API_BASE_URL = resolveApiBaseUrl();

export function apiErrorCode(source) {
    return String(
        source?.details?.code
        ?? source?.details?.Code
        ?? source?.code
        ?? source?.Code
        ?? source?.error?.code
        ?? source?.error?.Code
        ?? '',
    ).toUpperCase();
}

export function resolveApiErrorMessage(source, fallback = '') {
    if (apiErrorCode(source) === 'STARTER_LOADOUT_REQUIRED') {
        return 'Open your Starter Cache, take both items, and equip them before moving on.';
    }
    return source?.message || fallback;
}

export function buildApiUrl(path = '') {
    const normalizedPath = path && path[0] !== '/' ? `/${path}` : path;
    return `${API_BASE_URL}${normalizedPath}`;
}
// export const fetchValues = async () => {
//     const response = await fetch(`${API_BASE_URL}/test`);
//     if (!response.ok) {
//         throw new Error('Network response was not ok');
//     }
//     return response.json();
// };



const headers = {
    'ApiKey': apiKey,
    'Version': '0.1.0'
};

const headersAuth = () => {
    return {
        'ApiKey': apiKey,
        'Version': '0.1.0',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    }

};
// export const apiFetch = async (url, useAuth = false, options) => {

//     var ha = headersAuth();

//     const response = await fetch(API_BASE_URL + "/" + url, {
//         ...options,
//         headers: useAuth ? { ...options, ...ha } : { ...options, ...headers }
//     });



//     if (!response.ok) {
//         ResponseError(response);
//     }

//     return response;
// };

export const apiPost = async (url, formData, useAuth = true, options) => {


    var extraHeader = "";
    if (checkType(formData) === "JSON") {
        extraHeader = { 'Content-Type': 'application/json' };
    }
    var ha = headersAuth();
    //if url has no / in begin then add
    if (url[0] !== "/") {
        url = "/" + url;
    }
    const response = await fetchWithToast(buildApiUrl(url), {
        method: 'POST', body: formData, ...options,
        headers: useAuth ? { ...options, ...ha, ...extraHeader } : { ...options, ...headers, ...extraHeader }
    });



    if (!response.ok) {
        await ResponseError(response);
    }

    return response;
};

export const apiGet = async (url, useAuth = true, options) => {

    var ha = headersAuth();
    //if url has no / in begin then add
    if (url[0] !== "/") {
        url = "/" + url;
    }
    const response = await fetchWithToast(buildApiUrl(url), {
        method: 'GET', ...options,
        headers: useAuth ? { ...options, ...ha } : { ...options, ...headers }
    });
    // const response = await fetch(`${API_BASE_URL}/test`);

    if (!response.ok) {
        await ResponseError(response);

    }

    return response;
};

export const apiPut = async (url, formData, useAuth = true, options) => {

    var extraHeader = "";
    if (checkType(formData) === "JSON") {
        extraHeader = { 'Content-Type': 'application/json' };
    }

    var ha = headersAuth();
    //if url has no / in begin then add
    if (url[0] !== "/") {
        url = "/" + url;
    }

    const response = await fetchWithToast(buildApiUrl(url), {
        method: 'PUT', body: formData, ...options,
        headers: useAuth ? { ...options, ...ha, ...extraHeader } : { ...options, ...headers, ...extraHeader }
    });



    if (!response.ok) {
        await ResponseError(response);
    }

    return response;
};


export const apiDelete = async (url, useAuth = true, options) => {

    var ha = headersAuth();
    //if url has no / in begin then add
    if (url[0] !== "/") {
        url = "/" + url;
    }
    const response = await fetchWithToast(buildApiUrl(url), {
        method: 'DELETE', ...options,
        headers: useAuth ? { ...options, ...ha } : { ...options, ...headers }
    });



    if (!response.ok) {
        await ResponseError(response);
    }

    return response;
};

export default apiGet;

function checkType(data) {
    if (data instanceof FormData) {
        return 'FormData';
    }

    try {
        JSON.parse(data);
        return 'JSON';
    } catch (e) {
        return 'Unknown';
    }
}

async function fetchWithToast(url, options) {
    try {
        return await fetch(url, options);
    } catch (error) {
        ToastService.push('Unable to reach the server. Check your connection and try again.', 'error');
        throw error;
    }
}

function validationMessages(errors) {
    if (typeof errors === 'string') return [errors];
    if (Array.isArray(errors)) {
        return errors.flatMap(validationMessages);
    }
    if (!errors || typeof errors !== 'object') return [];

    const message = errors.message ?? errors.Message;
    if (typeof message === 'string' && message.trim()) {
        return [message];
    }
    return Object.values(errors).flatMap(validationMessages);
}

async function ResponseError(response) {
    if (response.status === 401) {
        localStorage.removeItem("token");
        window.location.href = '/login';
        return;
    }

    let body = null;
    try {
        body = await response.clone().json();
    } catch (error) {
        // Plain-text error responses are handled below.
    }

    const messages = validationMessages(body?.errors ?? body?.Errors);
    let message = messages.join(' | ');

    if (!message && typeof body === 'string') {
        message = body;
    }
    if (!message && body) {
        message = body.detail
            || body.Detail
            || body.error
            || body.Error
            || body.message
            || body.Message
            || body.title
            || body.Title
            || '';
    }
    if (!message) {
        try {
            const text = (await response.clone().text()).trim();
            if (text && !text.startsWith('<')) message = text;
        } catch (error) {
            // Fall back to the HTTP status below.
        }
    }

    const fallbackMessage = message
        || response.statusText
        || `Request failed (${response.status})`;
    message = messages.length > 0
        ? fallbackMessage
        : resolveApiErrorMessage(body, fallbackMessage);
    if (apiErrorCode(body) !== 'STARTER_REMOVAL_CONFIRMATION_REQUIRED') {
        ToastService.push(message, 'error');
    }
    const requestError = new Error(message);
    requestError.status = response.status;
    requestError.details = body;
    throw requestError;
}
